// @flow

import type { ItemType } from './components/ItemTypesFormSection';

export const MAX_ITEM_DETAILS = 5;
export const MIN_PHOTO_WIDTH = 500;
export const MIN_PHOTO_HEIGHT = 300;
export const MAX_PHOTO_SIZE = 500 * 1024; // 500KB;

export const GA_TRACKING_DISPLAYED = 'trade sourcing displayed';
export const GA_TRACKING_ENTRY = 'trade sourcing entry';
export const GA_TRACKING_SUBMITTED = 'trade sourcing submitted';

export const ONE_MONTH: '1 Month' = '1 Month';
export const TWO_MONTHS: '2 Months' = '2 Months';
export const THREE_MONTHS: '3 Months' = '3 Months';
export const FOUR_MONTHS: '4+ Months' = '4+ Months';
export const UNKNOWN_TIMEFRAME: 'Unknown' = 'Unknown';

export type NextProjectTimeframeOption =
    | typeof ONE_MONTH
    | typeof TWO_MONTHS
    | typeof THREE_MONTHS
    | typeof FOUR_MONTHS
    | typeof UNKNOWN_TIMEFRAME
    | '';

export const ITEM_TYPE_ANTIQUE: ItemType = 'antique/vintage';
export const ITEM_TYPE_CONTEMPORARY: ItemType = 'new/custom';

export const SOURCING_PROMPT_MODAL_ORIGIN_FOLDER: 'folder' = 'folder';
export const SOURCING_PROMPT_MODAL_ORIGIN_PROJECT: 'project' = 'project';

export type SourcingPromptModalOrigin =
    | typeof SOURCING_PROMPT_MODAL_ORIGIN_FOLDER
    | typeof SOURCING_PROMPT_MODAL_ORIGIN_PROJECT;
